import React, { useState } from 'react';
import { ReactComponent as CheckIcon } from 'assets/icons/green-circle-white-check.svg';
import {
  ApplyModalOverlay,
  ApplyModalBox,
  ApplyModalHeader,
  ApplyModalTitle,
  ApplyModalCloseButton,
  ApplyModalOption,
  ApplyModalOptionRadio,
  ApplyModalOptionText,
  ApplyModalOptionTitle,
  ApplyModalOptionDesc,
  ApplyModalButton,
  ApplyModalSuccessBody,
  ApplyModalSuccessIconWrapper,
  ApplyModalSuccessTitle,
  ApplyModalSuccessButton,
  SaveModalSpinner,
  SaveModalLoadingText,
} from './styled';

interface ApplyChangesModalProps {
  isSaving: boolean;
  isSuccess: boolean;
  onClose: () => void;
  onSuccessClose: () => void;
  onConfirm: (applyFuture: boolean) => void;
}

export const ApplyChangesModal: React.FC<ApplyChangesModalProps> = ({
  isSaving,
  isSuccess,
  onClose,
  onSuccessClose,
  onConfirm,
}) => {
  const [applyFuture, setApplyFuture] = useState(false);

  return (
    <ApplyModalOverlay>
      <ApplyModalBox onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        {isSaving ? (
          <>
            <SaveModalSpinner />
            <SaveModalLoadingText>Salvando alterações...</SaveModalLoadingText>
          </>
        ) : isSuccess ? (
          <>
            <ApplyModalHeader>
              <span />
              <ApplyModalCloseButton type="button" onClick={onSuccessClose}>
                ×
              </ApplyModalCloseButton>
            </ApplyModalHeader>
            <ApplyModalSuccessBody>
              <ApplyModalSuccessIconWrapper>
                <CheckIcon />
              </ApplyModalSuccessIconWrapper>
              <ApplyModalSuccessTitle>Alterações salvas com sucesso!</ApplyModalSuccessTitle>
              <ApplyModalSuccessButton type="button" onClick={onSuccessClose}>
                Entendi
              </ApplyModalSuccessButton>
            </ApplyModalSuccessBody>
          </>
        ) : (
          <>
            <ApplyModalHeader>
              <ApplyModalTitle>Como deseja aplicar as alterações?</ApplyModalTitle>
              <ApplyModalCloseButton type="button" onClick={onClose}>
                ×
              </ApplyModalCloseButton>
            </ApplyModalHeader>

            <ApplyModalOption selected={!applyFuture} onClick={() => setApplyFuture(false)}>
              <ApplyModalOptionRadio
                type="radio"
                checked={!applyFuture}
                onChange={() => setApplyFuture(false)}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              />
              <ApplyModalOptionText>
                <ApplyModalOptionTitle>Somente atividades selecionadas</ApplyModalOptionTitle>
                <ApplyModalOptionDesc>As próximas atividades do plano não serão alteradas.</ApplyModalOptionDesc>
              </ApplyModalOptionText>
            </ApplyModalOption>

            <ApplyModalOption selected={applyFuture} onClick={() => setApplyFuture(true)}>
              <ApplyModalOptionRadio
                type="radio"
                checked={applyFuture}
                onChange={() => setApplyFuture(true)}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              />
              <ApplyModalOptionText>
                <ApplyModalOptionTitle>Atividades selecionadas e futuras</ApplyModalOptionTitle>
                <ApplyModalOptionDesc>
                  As alterações serão aplicadas também às próximas atividades deste plano.
                </ApplyModalOptionDesc>
              </ApplyModalOptionText>
            </ApplyModalOption>

            <ApplyModalButton
              type="button"
              data-testid="btn-confirmar-aplicacao"
              onClick={() => onConfirm(applyFuture)}
            >
              Aplicar alterações
            </ApplyModalButton>
          </>
        )}
      </ApplyModalBox>
    </ApplyModalOverlay>
  );
};
